module.exports = __webpack_public_path__ + "static/img/banner_en.2d49c9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/banner_en.jpg
// module id = HYIy
// module chunks = 0